import classnames from 'classnames';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Feedback } from '../elements/common';
import { Component } from '../elements/Component';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface INumberInputProps {
    automation?: string;
    disabled?: boolean;
    error?: string;
    name?: string;
    onChange: (value: number | null) => void;
    onDoValidate?: (value: number | null) => void;
    placeholder?: string;
    text?: string;
    textStyle?: React.CSSProperties;
    value: number | null;
    width?: 'small' | 'medium' | 'large' | 'extraLarge';
}
export class NumberInput extends Component<FormContextProps<INumberInputProps>> {
    private changed = false;
    public render() {
        let width = '';
        switch (this.props.width) {
            case 'small':
                width = 'w-25';
                break;
            case 'medium':
                width = 'w-50';
                break;
            case 'large':
                width = 'w-75';
                break;
            case 'extraLarge':
                width = 'w-100';
                break;
            default:
                break;
        }

        return (
            <FormContextConsumer {...this.props}>
                {(properties) => (
                    <div className="number-input">
                        <div className={properties.text ? ' form-control-inline' : ''}>
                            <input
                                className={classnames(
                                    'form-control',
                                    properties.error ? 'form-control-danger' : '',
                                    this.props.automation ? 'automation-' + this.props.automation : '',
                                    width
                                )}
                                data-automation-test={this.props.automation}
                                disabled={properties.disabled}
                                key="input"
                                name={properties.name}
                                onBlur={(e) => {
                                    if (properties.onDoValidate && this.changed) {
                                        properties.onDoValidate(
                                            e.target.value === '' || isNaN(Number(e.target.value))
                                                ? null
                                                : Number(e.target.value)
                                        );
                                    }
                                }}
                                onChange={(e) => {
                                    this.changed = true;
                                    properties.onChange(
                                        e.target.value === '' || isNaN(Number(e.target.value))
                                            ? null
                                            : Number(e.target.value)
                                    );
                                }}
                                placeholder={properties.placeholder}
                                type="text"
                                value={properties.value || properties.value === 0 ? properties.value : ''}
                            />
                            {properties.text && (
                                <span
                                    className="input-description"
                                    style={this.props.textStyle}
                                >
                                    {properties.text}
                                </span>
                            )}
                        </div>
                        <Feedback
                            error={properties.error}
                            key="feedback"
                        />
                    </div>
                )}
            </FormContextConsumer>
        );
    }
}

export function NumberField(props: FormContextProps<INumberInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <NumberInput {...props} />
        </Field>
    );
}
